export default function Disclaimer() {
  return (
    <>
      <div className="seperator" />
      <blockquote className="disclaimer">
        <h4>
          <u>DISCLAIMER:</u>
        </h4>
        <p>
          The records contained in this reports are compiled from various
          databases that may only be updated infrequently, and therefore, may
          not have the most current information. This report is not intended to
          serve as recommendation of whether to contract the organization.
        </p>
        <p>
          This report is submitted in strict confidence and except where
          required by law, no information provided in this report may be
          revealed directly or indirectly to any person except to those whose
          official duties require them to pass this report on in relation to
          which the report was requested by the client.
        </p>
        <p>
          Peleza International Limited neither warrants, vouches for, or
          authenticates the reliability of the information contained herein that
          the records are accurately reported as they were found at the source
          as ofthe date and time of this report, whether on a computer
          information system, retrieved by manual search, or telephonic
          interviews. The information provided herein shall not be construed to
          constitute a legal opinion; rather it is a compilation of public
          records and/or data for your review. Peleza International Limited
          shall not be liable for any losses or injuries now or in the future
          resulting from or relating to the information provided herein.
        </p>
        <p>
          The recommended searches provided on our website should not serve as
          legal advice for your KYC. You should always seek legal advice from
          your attorney. The recommended searches are provided to helporient you
          to searches you may want to consider. We will work with you to create
          a KYC package specific to your industry needs.
        </p>
      </blockquote>
    </>
  );
}
